import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";

// Public pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Events from "@/pages/Events";
import Blog, { BlogPost } from "@/pages/Blog";
import Stories from "@/pages/Stories";
import Trust from "@/pages/Trust";
import Referrals from "@/pages/Referrals";
import ForReferrers from "@/pages/ForReferrers";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import FAQ from "@/pages/FAQ";

// Staff CRM
import StaffLogin from "@/pages/staff/StaffLogin";
import StaffLayout from "@/pages/staff/StaffLayout";
import StaffDashboard from "@/pages/staff/StaffDashboard";
import ClientsList from "@/pages/staff/ClientsList";
import ClientDetail from "@/pages/staff/ClientDetail";
import ReferralsList from "@/pages/staff/ReferralsList";
import MessagesList from "@/pages/staff/MessagesList";
import TeamManagement from "@/pages/staff/TeamManagement";
import Billing from "@/pages/staff/Billing";
import NDISRates from "@/pages/staff/NDISRates";
import MyProfile from "@/pages/staff/MyProfile";
import Noticeboard from "@/pages/staff/Noticeboard";
import BlogAdmin from "@/pages/staff/BlogAdmin";
import EventsAdmin from "@/pages/staff/EventsAdmin";
import Utilisation from "@/pages/staff/Utilisation";

function PublicLayout({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          {/* Public site */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/stories" element={<PublicLayout><Stories /></PublicLayout>} />
          <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
          <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
          <Route path="/blog/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
          <Route path="/trust" element={<PublicLayout><Trust /></PublicLayout>} />
          <Route path="/referrals" element={<PublicLayout><Referrals /></PublicLayout>} />
          <Route path="/for-referrers" element={<PublicLayout><ForReferrers /></PublicLayout>} />
          <Route path="/resources" element={<PublicLayout><Resources /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
          <Route path="/funding" element={<Navigate to="/faq#fees-funding" replace />} />
          <Route path="/fees" element={<Navigate to="/faq#fees-funding" replace />} />
          <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />

          {/* Staff CRM */}
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff" element={<ProtectedRoute><StaffLayout /></ProtectedRoute>}>
            <Route index element={<StaffDashboard />} />
            <Route path="clients" element={<ClientsList />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="referrals" element={<ReferralsList />} />
            <Route path="messages" element={<MessagesList />} />
            <Route path="billing" element={<Billing />} />
            <Route path="utilisation" element={<Utilisation />} />
            <Route path="noticeboard" element={<Noticeboard />} />
            <Route path="blog" element={<BlogAdmin />} />
            <Route path="events" element={<EventsAdmin />} />
            <Route path="profile" element={<MyProfile />} />
            <Route path="team" element={<ProtectedRoute adminOnly><TeamManagement /></ProtectedRoute>} />
            <Route path="rates" element={<ProtectedRoute adminOnly><NDISRates /></ProtectedRoute>} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
